<section class="section internal-share">
  <h3 class="header" data-test="internal-share-header">Internal Sharing Links</h3>
  <div class="share-info">
    Only signed in Members can view these Report links.
    <a
      data-test="learn-external-share"
      [attr.href]="helpDocs.links['https://mode.com/help/articles/report-scheduling-and-sharing']"
      >Learn more</a
    >
  </div>
  <div class="link-info-label">
    <label class="mode-label" data-test="internal-recent-label">Most recent run link</label>
    <capra-icon
      icon="icon-info-outline"
      capraTooltip
      [tooltipContent]="mostRecentRunMessage"
      tooltipPlacement="bottom"
    >
    </capra-icon>
  </div>
  <mode-copy-input
    [link]="internalLiveReportLink"
    buttonVariant="secondary"
    [trackCopyClick]="internalLiveReportEventPayload"
  ></mode-copy-input>
  <div class="link-info-label">
    <label class="mode-label" data-test="internal-static-label">Static run link</label>
    <capra-icon
      icon="icon-info-outline"
      capraTooltip
      [tooltipContent]="staticRunMessage"
      tooltipPlacement="bottom"
    >
    </capra-icon>
  </div>
  <mode-copy-input
    [link]="internalStaticReportLink"
    buttonVariant="secondary"
    [trackCopyClick]="internalStaticEventPayload"
  ></mode-copy-input>
</section>
<section data-test="external-share-sect" class="section external-share" [class.section-disabled]="!reportShared">
  <h3 class="header" data-test="external-share-header">External Sharing Links</h3>
  <div class="share-info">
    Anyone with these links can view the Report. Signing in to Mode is not required.
    <a
      [class.link-disabled]="!reportShared"
      data-test="learn-external-share"
      [attr.href]="helpDocs.links['https://mode.com/help/articles/report-scheduling-and-sharing']"
    >
      Learn more
    </a>
  </div>
  <div class="link-info-label">
    <label class="mode-label" data-test="external-recent-label">Most recent run link</label>
    <capra-icon
      icon="icon-info-outline"
      capraTooltip
      [tooltipContent]="mostRecentRunMessage"
      tooltipPlacement="bottom"
      [tooltipIsDisabled]="!reportShared"
    >
    </capra-icon>
  </div>
  <mode-copy-input
    [disabled]="!reportShared"
    [link]="externalLiveReportLink"
    buttonVariant="secondary"
    [trackCopyClick]="externalLiveReportLinkEventPayload"
  ></mode-copy-input>
  <div class="link-info-label">
    <label class="mode-label" data-test="external-static-label">Static run link</label>
    <capra-icon
      icon="icon-info-outline"
      capraTooltip
      [tooltipIsDisabled]="!reportShared"
      [tooltipContent]="staticRunMessage"
      tooltipPlacement="bottom"
    >
    </capra-icon>
  </div>
  <mode-copy-input
    [disabled]="!reportShared"
    [link]="externalStaticReportLink"
    buttonVariant="secondary"
    [trackCopyClick]="externalStaticReportEventPayload"
  ></mode-copy-input>
</section>
